import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ApiService } from '@core/providers/http';
import { MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
} from 'primeng/dynamicdialog';
import { FileUpload } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { StepperModule } from 'primeng/stepper';
import { TextareaModule } from 'primeng/textarea';
import { InputMask, InputMaskModule } from 'primeng/inputmask';
import {
  InstituicaoGestoraService,
  CommunicationService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { InstituicaoNaturezaEnum } from '../../api/models/institutionNaturezaEnum';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { MenuModule } from 'primeng/menu';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-cadastrar-instituicao-gestora',
  imports: [
    FormsModule,
    CommonModule,
    HttpClientModule,
    FileUpload,
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    TextareaModule,
    ButtonModule,
    StepperModule,
    InputMask,
    RadioButtonModule,
    DropdownModule,
    InputGroupAddonModule,
    MenuModule,
    InputGroup,
    ToastModule
  ],
  providers: [
    DialogService,
    ApiService,
    InstituicaoGestoraService,
  ],
  templateUrl: './cadastrar-instituicao-gestora.component.html',
  styleUrls: ['./cadastrar-instituicao-gestora.component.scss'],
  standalone: true,
})
export class CadastrarInstituicaoGestoraComponent implements OnInit {
  addEmpresaGestoraForm: FormGroup;
  activeStep: number = 1;
  listaInstituicaoGestora: any[] = [];

  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  ref = inject(DynamicDialogRef);
  instituicaoGestoraService = inject(InstituicaoGestoraService);
  fb = inject(FormBuilder);
  config = inject(DynamicDialogConfig);

  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;

  naturezasID = [
    { id: InstituicaoNaturezaEnum.Publica, designacao: 'Pública' },
    { id: InstituicaoNaturezaEnum.Privada, designacao: 'Privado' },
  ];
  private communicationService = inject(CommunicationService);
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  private subscriptions = new Subscription();

  selectedCountry: any = null;

  telefoneMask: string = '';
  telefonePlaceholder: string = '';
  paisTelefone: string = 'AO'; // valor padrão

  countryMenuItems = [
    {
      label: 'Angola (+244)',
      command: () => this.setPhoneMask('AO'),
    },
    {
      label: 'Brasil (+55)',
      command: () => this.setPhoneMask('BR'),
    },
    {
      label: 'Portugal (+351)',
      command: () => this.setPhoneMask('PT'),
    },
    {
      label: 'Estados Unidos (+1)',
      command: () => this.setPhoneMask('US'),
    },
    {
      label: 'Reino Unido (+44)',
      command: () => this.setPhoneMask('UK'),
    },
  ];

  constructor() {
    this.addEmpresaGestoraForm = this.fb.group({
      id: [0],
      Nome: ['', Validators.required],
      Endereco: ['', Validators.required],
      telefone1: ['', [Validators.required]],
      telefone2: [''],
      email: ['', [Validators.required, Validators.email]],
      Site: [''],
      Natureza: ['', Validators.required],
      paisID: ['', Validators.required],
      ProvinciaID: ['', Validators.required],
      MunicipioID: ['', Validators.required],
      Activo: [true],
      Foto: [''], // novo campo
    });

    this.addEmpresaGestoraForm.controls['paisID'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onCountryChange(value);
      }
    );

    this.addEmpresaGestoraForm.controls['ProvinciaID'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onProvinceChange(value);
      }
    );

    this.countries = this.config.data.countries;
    this.provinces = this.config.data.provinces;
    this.municipalities = this.config.data.municipalities;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.communicationService.provinces$.subscribe((provinces) => {
        this.provinces = provinces;
      })
    );
    this.subscriptions.add(
      this.communicationService.municipalities$.subscribe((municipalities) => {
        this.municipalities = municipalities;
      })
    );
  }

  onCountryChange(value: any) {
    this.communicationService.emitCountryChanged(value);
    // this.resetProvinceAndMunicipality();
  }

  resetProvinceAndMunicipality() {
    this.addEmpresaGestoraForm.patchValue({
      ProvinciaID: null,
      MunicipioID: null,
    });
  }

  resetMunicipality() {
    this.addEmpresaGestoraForm.patchValue({
      MunicipioID: null,
    });
  }

  onProvinceChange(value: any) {
    this.communicationService.emitProvinceChanged(value);
    // this.resetMunicipality();
  }

  // Example method to change mask
  setPhoneMask(countryCode: string): void {
    switch (countryCode) {
      case 'AO':
        this.telefoneMask = '(244) 999-999-999';
        this.telefonePlaceholder = '(+244) 999-999-999';
        break;
      case 'BR':
        this.telefoneMask = '(99) 99999-9999';
        this.telefonePlaceholder = '(+55) 99999-9999';
        break;
      case 'PT':
        this.telefoneMask = '(999) 999-999-999';
        this.telefonePlaceholder = '(+351) 999 999 999';
        break;
      case 'US':
        this.telefoneMask = '(999) 999-9999';
        this.telefonePlaceholder = '(+1) 999-999-9999';
        break;
      case 'UK':
        this.telefoneMask = '99999 999999';
        this.telefonePlaceholder = '(+44) 99999 999999';
        break;
      default:
        this.telefoneMask = '';
        this.telefonePlaceholder = '';
    }

    // this.addEmpresaGestoraForm.get('telefone1')?.reset();
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.addEmpresaGestoraForm.patchValue({ Foto: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
    /*this.file = event.currentFiles[0];
    console.log(this.file);
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result; // Store Base64 URL
    };
    reader.readAsDataURL(this.file);*/
  }

  save(): void {
    if (!this.addEmpresaGestoraForm.valid) {
      this.addEmpresaGestoraForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });

      if (this.addEmpresaGestoraForm.valid) {
        const rawData = this.addEmpresaGestoraForm.getRawValue();
        const formData = new FormData();

        for (const key in rawData) {
          if (key !== 'Foto') {
            formData.append(key, rawData[key]);
          }
        }

        if (rawData.Foto && this.selectedFile) {
          formData.append('Foto', this.selectedFile, this.selectedFile.name);
        }

        this.ref.close(formData); // envia o FormData para o componente pai
      } else {
        this.addEmpresaGestoraForm.markAllAsTouched();
        if (!this.selectedFile) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Por favor selecione uma imagem para o logotipo.',
          });
        }
      }
    }

    /*
    save(): void {
      if (this.addEmpresaGestoraForm.valid) {
        this.ref.close(this.addEmpresaGestoraForm.value);
      } else {
        this.addEmpresaGestoraForm.markAllAsTouched();
      }
    }*/


  }

  cancel() {
    this.ref.close();
  }

}
